// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/marca-asociada/list',
    name: 'marca-asociada-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/MarcaAsociada.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_marca_asociada_hotels',
    },
  },
]

export default formTable
